import React, { useState } from 'react';
import { Box, Popover, Tabs, Tab, IconButton } from '@mui/material';
import { COMMUNITY_EMOJI_CATEGORIES } from './communityEmojiData';

interface Props {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onSelect: (emoji: string) => void;
}

export const CommunityEmojiPicker: React.FC<Props> = ({ anchorEl, open, onClose, onSelect }) => {
  const [tab, setTab] = useState(0);
  const category = COMMUNITY_EMOJI_CATEGORIES[tab];

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      PaperProps={{
        sx: { borderRadius: 2, width: 320, maxHeight: 360, overflow: 'hidden' },
      }}
    >
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ minHeight: 40, borderBottom: '1px solid #e8eaed', px: 1 }}
      >
        {COMMUNITY_EMOJI_CATEGORIES.map((c) => (
          <Tab key={c.id} label={c.label} sx={{ minHeight: 40, fontSize: '0.72rem', py: 0 }} />
        ))}
      </Tabs>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(8, 1fr)',
          gap: 0.25,
          p: 1,
          maxHeight: 260,
          overflowY: 'auto',
        }}
      >
        {category.emojis.map((emoji) => (
          <IconButton
            key={emoji}
            size="small"
            onClick={() => {
              onSelect(emoji);
              onClose();
            }}
            sx={{ fontSize: '1.25rem', borderRadius: 1 }}
          >
            {emoji}
          </IconButton>
        ))}
      </Box>
    </Popover>
  );
};
